// extracted by mini-css-extract-plugin
module.exports = {"search":"search--2mjIV"};